import { Directive, Input, ElementRef, Renderer2 } from '@angular/core';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import { lazySizes } from 'lazysizes';
import { environment } from 'src/environments/environment';


@Directive({
  selector: '[appLazyload]'
})
export class LazyloadDirective {

  public tempImage: string = "assets/images/placeholders/placeholder_" + environment.features.posterType + ".png";
  @Input('appLazyload') imgSrc: string;
  @Input('appLazyPlaceholder') placeholder: string;
  public img; constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngOnInit() {
    this.img = this.imgSrc;
    
    // In case we need a specific placeholder type
    if(this.placeholder){
      this.tempImage = "assets/images/placeholders/placeholder_" + this.placeholder + ".png";
    }
    this.initLazyLoading();
    this.setAttributes();
  }

  initLazyLoading() {
    if (lazySizes) {
      lazySizes.init();
    }
  }

  setAttributes() {
    this.renderer.addClass(this.el.nativeElement, 'appLazyload');
    if (this.el.nativeElement.localName === 'img') {
      this.setImgSrc();
    } else {
      this.setElementBackgroundImage();
    }
  }

  setImgSrc() {
    this.renderer.setAttribute(this.el.nativeElement, 'data-src', this.img);
    this.renderer.setAttribute(this.el.nativeElement, 'src', this.tempImage);

  }

  setElementBackgroundImage() {
    this.renderer.setAttribute(this.el.nativeElement, 'data-bg', this.img);
    this.renderer.setStyle(this.el.nativeElement, 'background-image', `url(${this.tempImage})`);
  }
}